import { AfterViewInit, Component, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { TabsetComponent } from 'ngx-bootstrap/tabs';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from 'src/app/_services/api.service';


@Component({
    selector: 'app-officeLocations',
    templateUrl: './officeLocations.component.html',
    styleUrls: ['./officeLocations.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class OfficeLocationsComponent implements OnInit, AfterViewInit {

  @ViewChild('staticTabs', { static: false }) staticTabs: TabsetComponent;
  id: number = 0;

  selectTab(tabId: number) {
    this.staticTabs.tabs[tabId].active = true;
    this.id = tabId + 1;
  }

  HeadServices = false;
  markers: marker[] = [
	  {
      //HOA
		  lat: 34.0567361,
		  lng: -118.2459622,

	  },
	  {
      //North District
		  // lat: 34.32188946052673,
		  // lng: -118.49493026733398,
      //temporarily in hoa
      lat: 34.0567361,
		  lng: -118.2459622,
	  },
	  {
      //East District
		  lat: 34.0355747,
		  lng: -118.03935033,
	  },
	  {
      //South District
		  lat: 33.8047924888,
		  lng: -118.173543401,
	  },
	  {
      //West District
		  lat: 33.9848597,
		  lng: -118.3908681,
	  },
	  {
      //Lancaster
		  lat: 34.67001343,
		  lng: -118.12640381,
	  },
    {
      //Beverly Hill Courthouse
      lat:34.0726169,
      lng:-118.3980346,
    },
    {
      //Castaic Library
      lat:34.4958079,
      lng:-118.6275298,
    }
  ]
  constructor(private apiService: ApiService, private actRoute: ActivatedRoute) {
    this.id = this.actRoute.snapshot.params.id || null;
  }

  mapClicked(event: MouseEvent) {

  }


  ngAfterViewInit() {
    if(this.id !== null)
      this.selectTab(this.id -1);
  }

  ngOnInit() {

  }

}

interface marker {
	lat: number;
	lng: number;

}
